import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';
import {enableProdMode} from '@angular/core';

if (1!=1) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);




// WEBPACK FOOTER //
// ./src/app/main.ts